// TODO : SEEMS NOT IMPLEMENTED

interface PrivateDiscussionUserData {
  id?: number;
  privateDiscussionId?: number;
  userId?: number;
  lastSeen?: string;
  lastNotification?: string;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

}
export class PrivateDiscussionUser {
  public static getNonTranslatableFields(): string[] { return ['id', 'privateDiscussionId', 'userId', 'lastSeen', 'lastNotification', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'privateDiscussionId', 'userId', 'lastSeen', 'lastNotification', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  privateDiscussionId?: number;
  userId?: number;
  lastSeen?: string;
  lastNotification?: string;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;


  public static fromAPI(data: PrivateDiscussionUserData): PrivateDiscussionUser {
    return new PrivateDiscussionUser(data);
  }

  public static fromAPIList(data: PrivateDiscussionUserData[]): PrivateDiscussionUser[] {
    return data.map((item: PrivateDiscussionUserData) => PrivateDiscussionUser.fromAPI(item));
  }


   constructor({id, privateDiscussionId, userId, lastSeen, lastNotification, createDate, createrId, updateDate, updaterId, deleteDate, deleterId}: PrivateDiscussionUserData) {
      this.id = id;
      this.privateDiscussionId = privateDiscussionId;
      this.userId = userId;
      this.lastSeen = lastSeen;
      this.lastNotification = lastNotification;
      this.createDate = createDate;
      this.createrId = createrId;
      this.updateDate = updateDate;
      this.updaterId = updaterId;
      this.deleteDate = deleteDate;
      this.deleterId = deleterId;
   }

  public toJson(): PrivateDiscussionUserData {
    return {
      id: this.id,
      privateDiscussionId: this.privateDiscussionId,
      userId: this.userId,
      lastSeen: this.lastSeen,
      lastNotification: this.lastNotification,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId,
      deleteDate: this.deleteDate,
      deleterId: this.deleterId
    };
  }
}
